import { getBDCountry } from '@/common/utils/i18n'
import { get, set } from 'lodash-es'
import metaData, { Rule } from '@/mainConf/metaData/bizopp'
import rules from '@/mainConf/rules/bizopp'
const debug = false
const country = getBDCountry() || 'MX'
export const defaultExistTag = debug ? ['BR', 'JP'] : ['MX', 'BR', 'JP']

const isPlaneObject = obj => Object.prototype.toString.call(obj) === '[object Object]'
const getLowerCaseKey = str => str.substring(1).toLowerCase()
const isNotOther = key => getLowerCaseKey(key) !== 'other'
const isOther = key => getLowerCaseKey(key) === 'other'
const getValue = (data, path) => get(data, path)
const isQueryObject = obj => {
  if (isPlaneObject(obj)) {
    const kys = Object.keys(obj)
    return kys.length > 0 && kys.every(key => /^@\w+/.test(key))
  }
  return false
}
let rulesMap
function fillValueByConf(configs, data) {
  return configs
    .map(conf => {
      let value
      if (conf.viewType === 'map') {
        value = get(conf, 'mapConfig', []).reduce((map, item) => {
          map[item.value] = item.label
          return map
        }, {})[get(data, conf.prop)]
      } else if (conf.viewType === 'file') {
        value = (get(data, conf.prop, []) || []).map(item => {
          return item.url
        })
      } else {
        value = get(data, conf.prop)
      }
      if (conf.label && !conf.viewDisabled) {
        if (Object.prototype.toString.call(get(data, conf.prop)) === '[object Object]') {
          const d = {
            ...conf,
            hide: conf.hide ? conf.hide : conf.checkVisible ? !conf.checkVisible(data) : false,
            value,
            type: conf.viewType ? conf.viewType : conf.type,
            images:
              conf.viewType === 'image'
                ? (get(data, conf.prop, {}) || {}).urls.map(item => {
                    return item.url || item
                  })
                : '',
          }
          return d
        } else {
          return {
            ...conf,
            hide: conf.hide ? conf.hide : conf.checkVisible ? !conf.checkVisible(data) : false,
            value,
            type: conf.viewType ? conf.viewType : conf.type,
            images:
              conf.viewType === 'image'
                ? (get(data, conf.prop, []) || []).map(item => {
                    return item.url || item
                  })
                : '',
          }
        }
      } else {
        return ''
      }
    })
    .filter(item => {
      if (item) {
        return item
      } else {
        return false
      }
    })
}
const removeUndefined = obj => {
  return Object.keys(obj).reduce((target, key) => {
    if (obj[key] != null) {
      target[key] = obj[key]
    }
    return target
  }, {})
}
const setGetter2Prop = obj => {
  /** 为了用fillValueByConf加的兼容方法 */
  const clone = Object.keys(obj).reduce((target, key) => {
    target[key] = obj[key]
    return target
  }, {})
  clone.prop = clone.getter || clone.prop
  return clone
}
const formatValue = obj => {
  if (isQueryObject(obj)) {
    const condition = Object.keys(obj).filter(isNotOther)
    const others = Object.keys(obj).filter(isOther)
    const fd = condition.find(condKey => {
      const condKeyFmt = getLowerCaseKey(condKey)
      const fn = rulesMap[condKeyFmt]
      if (typeof fn !== 'function') {
        return console.error(`此条规则配置错误,${condKey}请核对规则设置`)
      }
      return fn.call(this)
    })
    if (fd) {
      return obj[fd]
    }
    const [otherFn] = others
    if (otherFn) {
      return obj[otherFn]
    }
  }
  if (obj && obj.constructor === Rule) {
    const fn = obj.getRule()
    return fn && fn.call(this)
  }
  if (isPlaneObject(obj)) {
    return Object.keys(obj).reduce((target, key) => {
      target[key] = formatValue(obj[key])
      return target
    }, {})
  }
  if (Array.isArray(obj)) {
    return obj.map(item => {
      return formatValue(item)
    })
  }
  return obj
}

const getDataByPath = (obj, path) => {
  try {
    const d = formatValue(get(obj, path))
    if (d == null) {
      throw new Error(`元数据没有配置"${path}"字段`)
    }
    return d
  } catch (e) {
    console.error(e)
    return null
  }
}

const makeGetFormat = arr => {
  return obj => {
    return arr.reduce((target, key) => {
      if (obj[key] != null) {
        target[key] = obj[key]
      }
      return target
    }, {})
  }
}

const recursiveMaker = function (mdata, callback) {
  const getData = parents => {
    return item => {
      if (Array.isArray(item)) {
        const fmtobj = item[1] || {}
        const { ext = {} } = fmtobj
        const getFormat = makeGetFormat(['disabled'])
        const data = getDataByPath(mdata, item[0])
        if (data == null) {
          throw new Error(`元数据没有配置"${item[0]}"字段`)
        }
        const dt = callback(data, parents, ext)
        const obj = Object.assign(dt, getFormat(fmtobj))
        return obj
      }
      if (typeof item === 'string') {
        const data = getDataByPath(mdata, item)
        if (data == null) {
          throw new Error(`元数据没有配置"${item}"字段`)
        }
        const dt = callback(data, parents)
        const obj = Object.assign(
          dt,
          this.disabled || parents.some(d => d.disabled)
            ? {
                disabled: true,
              }
            : {},
        )
        return obj
      }
      /** 针对目前字段名称不统一做的权衡手段 */
      const recursiveKey = ['list', 'config', 'configs', 'attributes'].find(key => {
        return Object.prototype.hasOwnProperty.call(item, key)
      })
      if (Array.isArray(item[recursiveKey])) {
        item[recursiveKey] = item[recursiveKey]
          .filter(d => {
            if (isPlaneObject(d) && d.hide && d.type !== 'static') {
              return false
            }
            return true
          })
          .map(getData(parents.concat(item)))
          .filter(d => {
            return d => d != null
          })
      }
      return item
    }
  }
  return getData
}

const isValidadData = val => {
  if (val == null) return false
  if (typeof val === 'number' && isNaN(val)) return false
  if (val === '') return false
  return true
}

const getLabelValue = label => {
  if (typeof label === 'object' && label.constructor === Rule) {
    const fn = label.getRule()
    return fn && fn.call(this)
  }
  return label
}

const addDebugTags = obj => {
  /** 递归给每一个是新方法创建的配置打上标签 */
  const reducer = data => {
    return (target, key) => {
      const item = data[key]
      if (isPlaneObject(item)) {
        target[key] = !Object.prototype.hasOwnProperty.call(item, 'label')
          ? Object.keys(item).reduce(reducer(item), {})
          : Object.assign(item, {
              label: `${getLabelValue(item.label)}@${country}`,
            })
      }
      return target
    }
  }
  return process.env.NODE_ENV === 'development' ? Object.keys(obj).reduce(reducer(obj), {}) : obj
}

export const submitDataFormatter = function (config, data) {
  const _this = this
  /** 递归去配置format的方法 */
  const mdata =
    process.env.NODE_ENV === 'production'
      ? metaData.call(_this)
      : addDebugTags(metaData.call(_this))
  const getFormatData = data => {
    data = data == null ? {} : data
    return (target, item) => {
      if (isPlaneObject(item) && item.disabled) {
        return target
      }
      if (Array.isArray(item)) {
        const { ext = {} } = item[1]
        const conf = item[1]
        const { getter } = conf
        const format =
          conf.format ||
          function (val) {
            return val
          }
        const obj = Object.assign(get(mdata, item[0]) || {}, ext)
        const key = conf.newKey || obj.prop
        const keyObj =
          typeof key === 'object'
            ? key
            : {
                [key]: function (val) {
                  return val
                },
              }
        if (key == null) {
          console.warn(obj, conf)
        }
        const val = format.call(_this, get(data, getter || obj.prop), data)
        Object.keys(keyObj).reduce((target, key) => {
          const fn = keyObj[key]
          const value = fn.call(_this, val)
          if (isValidadData(value)) {
            console.info(key, value)
            set(target, key, value)
          }
          return target
        }, target)
      }
      if (typeof item === 'string') {
        const obj = get(mdata, item) || {}
        const { prop } = obj
        if (prop == null) {
          console.warn(obj)
        }
        const val = data[prop] == null ? obj.value : data[prop]
        if (isValidadData(val)) {
          target[prop] = val
        }
      }
      if (Array.isArray(item.attributes)) {
        if (item.prop == null) {
          console.warn(item.prop, item)
        }
        const dt = item.attributes
          .filter(d => {
            if (isPlaneObject(d) && d.hide) {
              return false
            }
            return true
          })
          .reduce(getFormatData(data[item.prop]), target[item.prop] || {})
        if (Object.keys(dt).length > 0) {
          target[item.prop] = dt
        }
      }
      if (Array.isArray(item.list)) {
        item.list
          .filter(d => {
            if (isPlaneObject(d) && d.hide) {
              return false
            }
            return true
          })
          .reduce(getFormatData(data), target)
      }
      return target
    }
  }
  if (defaultExistTag.indexOf(country) === -1) {
    const rs = typeof config === 'function' ? config.call(this, data) : null
    if (rs == null) {
      console.error(`(开国)fail: schemaGenerator没有获取到哥斯达黎加配置`)
      return
    } else {
      // console.info(`(开国)success: schemaGenerator获取到哥斯达黎加配置`)
    }
    if (Array.isArray(rs)) {
      return rs.reduce(getFormatData(data, []), {})
    }
    return Object.keys(rs).reduce((target, key) => {
      if (Array.isArray(rs[key])) {
        target[key] = rs[key].reduce(getFormatData(data, []), {})
      }
      return target
    }, {})
  }
}

export const schemaDetailGenerator = function (config, data) {
  if (data == null) {
    throw new Error('请确保详情页面传了数据data进来')
  }
  const mdata =
    process.env.NODE_ENV === 'production' ? metaData.call(this) : addDebugTags(metaData.call(this))
  const ruleDt = rules.call(this)
  rulesMap = Object.keys(ruleDt).reduce((target, key) => {
    target[key.toLowerCase()] = ruleDt[key]
    return target
  }, {})
  const getData = recursiveMaker.call(
    this,
    mdata,
    (
      { label, prop, format: fmt, detailView = {}, hide = false, checkVisible },
      parents,
      ext = {},
    ) => {
      // console.log(parents)
      const dt = Object.assign({ label, prop, format: fmt, hide, checkVisible }, detailView, ext)
      const { format = getValue, prop: pr, getter } = dt
      const path = getter || pr
      const [rs] = fillValueByConf([setGetter2Prop(dt)], data)
      rs.value = format(data, path)
      return removeUndefined(rs)
    },
  )

  if (defaultExistTag.indexOf(country) === -1) {
    const rs = typeof config === 'function' ? config.call(this, data) : null
    if (rs == null) {
      console.error(`(开国)fail: schemaGenerator没有获取到哥斯达黎加配置`)
      return
    } else {
      // console.info(`(开国)success: schemaGenerator获取到哥斯达黎加配置`)
    }
    if (Array.isArray(rs)) {
      return rs.map(getData([])).filter(d => d.hide !== true && d.type !== 'static')
    }
    return Object.keys(rs).reduce((target, key) => {
      target[key] = rs[key].map(getData([]))
      return target
    }, {})
  }
}

export const schemaGenerator = function (config, data) {
  const mdata =
    process.env.NODE_ENV === 'production' ? metaData.call(this) : addDebugTags(metaData.call(this))
  const ruleDt = rules.call(this)
  rulesMap = Object.keys(ruleDt).reduce((target, key) => {
    target[key.toLowerCase()] = ruleDt[key]
    return target
  }, {})
  const getData = recursiveMaker.call(this, mdata, (d, parents, ext = {}) => {
    return Object.assign(d, ext)
  })
  if (defaultExistTag.indexOf(country) === -1) {
    const rs = typeof config === 'function' ? config.call(this, data) : null

    if (rs == null) {
      console.error(`(开国)fail: schemaGenerator没有获取到哥斯达黎加配置`)
      return
    } else {
      // console.info(`(开国)success: schemaGenerator获取到哥斯达黎加配置`)
    }
    if (Array.isArray(rs)) {
      return rs.map(getData([])).filter(d => d.hide !== true && d.type !== 'static')
    }
    return process.env.NODE_ENV === 'development'
      ? Object.keys(rs).reduce((target, key) => {
          target[key] = Array.isArray(rs[key]) ? rs[key].map(getData([])) : rs[key]
          return target
        }, {})
      : rs
  }
}

// normal改造schema生成器，为bizopp元数据加入参数checkFields,用于在sign-link组件获取到实际的表单数据
export const schemaGeneratorV2 = function (config, data, checkFields = false) {
  const mdata =
    process.env.NODE_ENV === 'production'
      ? metaData.call(this, checkFields)
      : addDebugTags(metaData.call(this, checkFields))
  const ruleDt = rules.call(this)
  rulesMap = Object.keys(ruleDt).reduce((target, key) => {
    target[key.toLowerCase()] = ruleDt[key]
    return target
  }, {})
  const getData = recursiveMaker.call(this, mdata, (d, parents, ext = {}) => {
    return Object.assign(d, ext)
  })
  // normal改造，老国家也改造为元数据配置的方式
  const rs = typeof config === 'function' ? config.call(this, data) : null
  if (rs == null) {
    console.error(`(开国)fail: schemaGenerator没有获取到哥斯达黎加配置`)
    return
  } else {
    // console.info(`(开国)success: schemaGenerator获取到哥斯达黎加配置`)
  }
  if (Array.isArray(rs)) {
    return rs.map(getData([])).filter(d => d.hide !== true && d.type !== 'static')
  }
  return process.env.NODE_ENV === 'development'
    ? Object.keys(rs).reduce((target, key) => {
        target[key] = Array.isArray(rs[key]) ? rs[key].map(getData([])) : rs[key]
        return target
      }, {})
    : rs
}
// normal改造数据提交格式化，去除isValidadData，修复非必填字段不能删除的bug,参数过滤由对应页面完成
export const submitDataFormatterV2 = function (config, data) {
  const _this = this
  /** 递归去配置format的方法 */
  const mdata =
    process.env.NODE_ENV === 'production'
      ? metaData.call(_this)
      : addDebugTags(metaData.call(_this))
  const getFormatData = data => {
    data = data == null ? {} : data
    return (target, item) => {
      if (isPlaneObject(item) && item.disabled) {
        return target
      }
      if (Array.isArray(item)) {
        const { ext = {} } = item[1]
        const conf = item[1]
        const { getter } = conf
        const format =
          conf.format ||
          function (val) {
            return val
          }
        const obj = Object.assign(get(mdata, item[0]) || {}, ext)
        const key = conf.newKey || obj.prop
        const keyObj =
          typeof key === 'object'
            ? key
            : {
                [key]: function (val) {
                  return val
                },
              }
        if (key == null) {
          console.warn(obj, conf)
        }
        const val = format.call(_this, get(data, getter || obj.prop), data)
        Object.keys(keyObj).reduce((target, key) => {
          const fn = keyObj[key]
          const value = fn.call(_this, val)
          // if (isValidadData(value)) {
          //   console.info(key, value)
          //   set(target, key, value)
          // }
          set(target, key, value)
          return target
        }, target)
      }
      if (typeof item === 'string') {
        const obj = get(mdata, item) || {}
        const { prop } = obj
        if (prop == null) {
          console.warn(obj)
        }
        const val = data[prop] == null ? obj.value : data[prop]
        // if (isValidadData(val)) {
        //   target[prop] = val
        // }
        target[prop] = val
      }
      if (Array.isArray(item.attributes)) {
        if (item.prop == null) {
          console.warn(item.prop, item)
        }
        const dt = item.attributes
          .filter(d => {
            if (isPlaneObject(d) && d.hide) {
              return false
            }
            return true
          })
          .reduce(getFormatData(data[item.prop]), target[item.prop] || {})
        if (Object.keys(dt).length > 0) {
          target[item.prop] = dt
        }
      }
      if (Array.isArray(item.list)) {
        item.list
          .filter(d => {
            if (isPlaneObject(d) && d.hide) {
              return false
            }
            return true
          })
          .reduce(getFormatData(data), target)
      }
      return target
    }
  }
  // normal改造老国家也可以使用schema元数据配置方式
  const rs = typeof config === 'function' ? config.call(this, data) : null
  if (rs == null) {
    console.error(`(开国)fail: schemaGenerator没有获取到哥斯达黎加配置`)
    return
  } else {
    // console.info(`(开国)success: schemaGenerator获取到哥斯达黎加配置`)
  }
  if (Array.isArray(rs)) {
    console.log('rsarray')
    return rs.reduce(getFormatData(data, []), {})
  }
  return Object.keys(rs).reduce((target, key) => {
    console.log('obj')
    if (Array.isArray(rs[key])) {
      target[key] = rs[key].reduce(getFormatData(data, []), {})
    }
    return target
  }, {})
}
